import React, { Fragment, useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { ButtonModalFormSaveClose } from "./ButtonModalSelection";

const RejectTimesheet = ({ shift, onComplete, close = null }) => {
  const { authAxios } = useAuth();
  const [loading, setLoading] = useState(false);
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [rejectReason, setRejectReason] = useState("");
  const [rejectReasonValid, setRejectReasonValid] = useState(false);

  useEffect(() => {
    var valid =
      rejectReason !== null &&
      rejectReason !== undefined &&
      rejectReason.trim().length > 0;
    setRejectReasonValid(valid);
  }, [rejectReason]);

  useEffect(() => {
    var valid = rejectReasonValid;
    setSaveDisabled(!valid);
  }, [rejectReason, rejectReasonValid]);

  const onSave = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);

      var params = {
        timesheet_id: shift?.timesheet?.id,
        reject_reason: rejectReason,
      };

      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: params,
      };
      const response = await authAxios().post(
        "/api/backoffice/timesheet/reject",
        null,
        config,
      );

      const fetchConfig = {
        headers: {
          "content-type": "application/json",
        },
        params: {
          shift_id: shift?.id,
        },
      };

      const shiftResponse = await authAxios().get(
        "/api/backoffice/shifts/" +
          (shift?.table === "shifts" ? "active" : "archive"),
        fetchConfig,
      );

      setLoading(false);
      onComplete(shiftResponse.data);
    } catch (err) {
      setLoading(false);
      console.log("error:");
      console.log(err);
    }
  };

  const rejectReasonChanged = (value) => {
    var text = value.target.value;
    setRejectReason(text.trim());
  };

  return (
    <Fragment>
      <Form>
        <Form.Group className="mb-3" controlId="formRejectReason">
          <Row>
            <Col xs lg="2">
              <Form.Label>Reject Reason</Form.Label>
            </Col>
            <Col xs lg="4">
              <Form.Control
                type="text"
                onChange={rejectReasonChanged}
                isValid={rejectReasonValid}
                isInvalid={!rejectReasonValid}
                required
              />
              <Form.Control.Feedback type="invalid">
                Need reject reason for {shift?.user?.surname},{" "}
                {shift?.user?.forename}
              </Form.Control.Feedback>
            </Col>
          </Row>
        </Form.Group>

        <ButtonModalFormSaveClose
          saveName={"Save"}
          close={close}
          formSave={onSave}
          loading={saveDisabled}
        />
      </Form>
    </Fragment>
  );
};

export default RejectTimesheet;
